import React from "react";
import Image from "../../designLayouts/Image";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectFilters } from "../../../redux/filtersSlice";
const Product = (props) => {
  const _id = props?._id;
  const idString = (_id) => {
    return String(_id)?.toLowerCase()?.split(" ")?.join("");
  };
  const rootId = idString(_id);
  const { ratio: aspect_ratio = "1/1" } =
    useSelector(selectFilters)?.filters || {};
  const navigate = useNavigate();

  // Parse numerical values
  const price = parseFloat(props?.price?.replace(/,/g, "")) || 0;
  const disc_price = parseFloat(props?.disc_price?.replace(/,/g, "")) || 0;

  const handleProductDetails = () => {
    navigate(`/product/${rootId}`);
  };
  const display_stock = Number(sessionStorage.getItem("display_stock"));
  return (
    <div className="w-full relative border border-gray-200 rounded-lg overflow-hidden h-full flex flex-col text-sm">
      {/* Product Image */}
      <div
        className="relative cursor-pointer bg-gray-500"
        onClick={handleProductDetails}
      >
        <Image
          className="w-full object-cover object-center"
          imgSrc={props?.img}
          alt={props?.productName}
          aspectRatio={aspect_ratio}
        />
      </div>

      {/* Product Details */}
      <div
        className="px-4 py-4 cursor-pointer flex-grow flex flex-col"
        onClick={handleProductDetails}
      >
        <p className="font-bold whitespace-normal break-words">{props?.sku}</p>
        <p className="whitespace-normal break-words">{props?.productName}</p>
        <div className="flex justify-between mt-auto">
          {display_stock === 1 ? (
            props?.stock > 0 ? (
              <p className="text-sm mt-auto">
                {props?.stock} {props?.unit}
              </p>
            ) : (
              <p className="text-sm font-semibold text-red-600 mt-auto">
                Out Of Stock
              </p>
            )
          ) : display_stock === 2 ? (
            <p className="text-sm font-semibold mt-auto">
              {props?.stock > 0 ? (
                <span>Available</span>
              ) : (
                <span className="text-red-500">Out Of Stock</span>
              )}
            </p>
          ) : (
            <p className="text-sm font-semibold mt-auto invisible">void</p>
          )}
          <div className="text-sm">
            {props?.disc_perc && disc_price && disc_price !== price ? (
              <div className="flex flex-row-reverse items-start gap-4">
                {/* Pricing Information */}
                <div>
                  {/* Original Price */}
                  <p>
                    <span className="font-semibold text-sm line-through decoration-red-500 text-red-500">
                      {props?.curr}{" "}
                    </span>
                    <span className="line-through decoration-red-500 text-red-500">
                      {props?.price}
                    </span>
                  </p>
                  {/* Discount Price */}
                  <p className="font-medium">
                    <span className="font-semibold text-sm">
                      {props?.curr}{" "}
                    </span>
                    <span className="font-medium text-sm">
                      {props?.disc_price}
                    </span>
                  </p>
                </div>
                {/* Discount Percentage */}
                <div className="bg-green-500 text-white aspect-square p-1 rounded-full flex items-center justify-center my-auto text-sm font-bold">
                  {Number(props?.disc_perc)?.toFixed(0)}%
                </div>
              </div>
            ) : (
              // Display only the original price if no discount
              price >= 0 && (
                <p>
                  <span className="font-semibold text-sm">{props?.curr} </span>
                  {props?.price}
                </p>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
